import { PageHeader } from '@/shared/components';
import { QuarantinedRevisionsCard } from './QuarantinedRevisionsCard';

/**
 * „Nicht zugeordnet“ (Board „Buchungen · Nicht zugeordnet“): Kanalbuchungen, die angekommen sind,
 * aber noch keinem Apartment zugeordnet werden konnten. Der Weg zurück steht im Pfad des Kopfs.
 * Verwaltung und Mitarbeiter, nicht Kunde und Reinigung.
 */
export function BookingQuarantinePage() {
  return (
    <>
      <PageHeader
        title="Nicht zugeordnet"
        description="Kanalbuchungen, die angekommen sind, aber noch keinem Apartment zugeordnet werden konnten – wartend oder in der Quarantäne, jeweils mit Grund."
      />
      <QuarantinedRevisionsCard />
    </>
  );
}
